import omit from 'lodash/omit'

export default function visitor(state = null, action) {
  switch (action.type) {
    case 'RESET_VISITOR':
      return action.payload
    case 'UPDATE_VISITOR':
      return { ...state, ...action.payload }
    case 'RECEIVE_INITIAL_SESSION':
      const visitorWithoutAddresses = omit(action.payload.visitor, 'addresses')
      return { ...state, ...visitorWithoutAddresses }
    default:
      return state
  }
}
